import { Map as IMap } from 'immutable';
import { createSelector } from 'reselect';

export const getLoader = state => state.get('loader', IMap());

export const getLoaderStatus = createSelector(
    getLoader,
    loader => loader.get('isLoading')
);
